// extracted by mini-css-extract-plugin
module.exports = {"googleButton":"googleButton__3J5_B","googleButtonIcon":"googleButtonIcon__3zzHQ","googleButtonText":"googleButtonText__1bfy0","circleIcon":"circleIcon__buSeI"};